export function normalizeTrimmedText(value: string | null | undefined): string {
  return value?.trim() ?? '';
}

export function hasMeaningfulText(value: string | null | undefined): boolean {
  return normalizeTrimmedText(value).length > 0;
}

export function isMissingMeaningfulText(value: string | null | undefined): boolean {
  return !hasMeaningfulText(value);
}